module.exports = __webpack_public_path__ + "media/metronic/_theme/media/blog/blog4-c8aba64b7194f65bc75fcd192b47029a.jpg";